<template>
  <div class='is-flex' :class='isMovil ? "is-justify-center" : "" '>
    <div class="field">
      <div class="control has-icons-left">
        <div class="select is-dark">
          <select v-model='typeSelected'>
            <option value='colaboradores' selected>Colaboradores</option>
            <option value='autoevaluacion'>Autoevaluación</option>
            <option value='autoconciencia'>Autoconciencia</option>
          </select>
        </div>
        <div class="icon is-small is-left">
          <i class="material-icons" style='color: #510087 !important;'>filter_list</i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  data(){
    return {
      typeSelected: 'colaboradores',
      groups: [
        ["colaboradores", "e"],
        ["autoevaluacion", "e"],
        ["autoconciencia", "r"]
      ],
    }
  },
  props:{
    proceso: Object
  },
  computed:{
    ...mapState(['isMovil']),
  },
  methods:{
    selectTypeData(type){
      this.$emit('selectTypeData', type)
    }
  },
  watch:{
    typeSelected(nv) {
      if (nv){
        this.selectTypeData(nv)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lideres/components/menuTableLeaders.vue